import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

// Translations for Admin Panel
export const translations = {
  // Sidebar Navigation
  sidebar: {
    activeRequests: { ro: "Cereri Active", en: "Active Requests" },
    archived: { ro: "Arhivate", en: "Archived" },
    paidInvoices: { ro: "Facturi Plătite", en: "Paid Invoices" },
    clientSite: { ro: "Site Client", en: "Client Site" },
    userManagement: { ro: "Gestionare Utilizatori", en: "User Management" },
    activityLogs: { ro: "Jurnal Activități", en: "Activity Logs" },
    security2fa: { ro: "Securitate (2FA)", en: "Security (2FA)" },
    documentation: { ro: "Documentație", en: "Documentation" },
    signOut: { ro: "Deconectare", en: "Sign Out" },
    shareRts: { ro: "Partajează RTS Express", en: "Share RTS Express" },
    linkStaff: { ro: "Link Staff", en: "Link Staff" },
    linkCopied: { ro: "Link Copiat!", en: "Link Copied!" },
  },
  
  // Sidebar Stats
  sidebarStats: {
    title: { ro: "Statistici Rapide", en: "Quick Stats" },
    totalRequests: { ro: "Total Cereri", en: "Total Requests" },
    new: { ro: "Noi", en: "New" },
    quoted: { ro: "Cotate", en: "Quoted" },
    paid: { ro: "Plătite", en: "Paid" },
    collected: { ro: "Preluate", en: "Collected" },
    delivered: { ro: "Livrate", en: "Delivered" },
  },
  
  // Page Headers
  headers: {
    requestsAdmin: { ro: "CERERI", en: "REQUESTS" },
    admin: { ro: "ADMIN", en: "ADMIN" },
    archivedAdmin: { ro: "ARHIVATE", en: "ARCHIVED" },
    invoicesAdmin: { ro: "FACTURI PLĂTITE", en: "PAID INVOICES" },
    manageRequests: { ro: "Gestionează cererile de transport", en: "Manage transport requests" },
    archivedRequests: { ro: "Cereri arhivate", en: "Archived requests" },
    autoGeneratedInvoices: { ro: "Facturi generate automat după plată", en: "Auto-generated invoices after payment" },
    refresh: { ro: "Reîmprospătare", en: "Refresh" },
  },
  
  // Stats Cards
  statsCards: {
    new: { ro: "Noi", en: "New" },
    quoted: { ro: "Cotate", en: "Quoted" },
    paid: { ro: "Plătite", en: "Paid" },
    collected: { ro: "Preluate", en: "Collected" },
    delivered: { ro: "Livrate", en: "Delivered" },
    active: { ro: "Activ", en: "Active" },
  },
  
  // Total Paid Banner
  totalPaid: {
    title: { ro: "Total Încasat (Comenzi Plătite)", en: "Total Collected (Paid Orders)" },
    fromOrders: { ro: "Din", en: "From" },
    paidOrders: { ro: "comenzi plătite", en: "paid orders" },
  },
  
  // Bulk Actions
  bulkActions: {
    selected: { ro: "selectat", en: "selected" },
    selectedPlural: { ro: "selectate", en: "selected" },
    paidWillBeSkipped: { ro: "Cererile plătite vor fi sărite", en: "Paid requests will be skipped" },
    archiveSelected: { ro: "Arhivează selectate", en: "Archive selected" },
    unarchiveSelected: { ro: "Dezarhivează selectate", en: "Unarchive selected" },
    cancel: { ro: "Anulează", en: "Cancel" },
  },
  
  // Search & Filter
  searchFilter: {
    searchPlaceholder: { ro: "Caută după companie, contact, postcode...", en: "Search by company, contact, postcode..." },
    allStatuses: { ro: "Toate statusurile", en: "All statuses" },
    all: { ro: "Toate", en: "All" },
    activeFilter: { ro: "Filtru activ:", en: "Active filter:" },
    results: { ro: "rezultat", en: "result" },
    resultsPlural: { ro: "rezultate", en: "results" },
  },
  
  // Table Headers
  tableHeaders: {
    company: { ro: "Companie", en: "Company" },
    route: { ro: "Rută", en: "Route" },
    cargo: { ro: "Marfă", en: "Cargo" },
    urgency: { ro: "Urgență", en: "Urgency" },
    status: { ro: "Status", en: "Status" },
    price: { ro: "Preț", en: "Price" },
    actions: { ro: "Acțiuni", en: "Actions" },
  },
  
  // Table Content
  tableContent: {
    pickup: { ro: "Pickup", en: "Pickup" },
    delivery: { ro: "Livrare", en: "Delivery" },
    view: { ro: "Vezi", en: "View" },
    loading: { ro: "Se încarcă...", en: "Loading..." },
    noRequests: { ro: "Nu sunt cereri", en: "No requests" },
    noArchivedRequests: { ro: "Nu sunt cereri arhivate", en: "No archived requests" },
  },
  
  // Status Labels
  statusLabels: {
    new: { ro: "Nou", en: "New" },
    quoted: { ro: "Cotat", en: "Quoted" },
    paid: { ro: "Plătit", en: "Paid" },
    collected: { ro: "Preluat", en: "Collected" },
    delivered: { ro: "Livrat", en: "Delivered" },
  },
  
  // Urgency Labels
  urgencyLabels: {
    immediate: { ro: "Imediat", en: "Immediate" },
    same_day: { ro: "În aceeași zi", en: "Same Day" },
    overnight: { ro: "Peste noapte", en: "Overnight" },
  },
  
  // Invoices Table
  invoicesTable: {
    invoice: { ro: "Factura", en: "Invoice" },
    client: { ro: "Client", en: "Client" },
    email: { ro: "Email", en: "Email" },
    paidAt: { ro: "Plătit la", en: "Paid at" },
    period: { ro: "Perioadă", en: "Period" },
    amount: { ro: "Sumă", en: "Amount" },
    loadingInvoices: { ro: "Se încarcă facturile...", en: "Loading invoices..." },
    noInvoices: { ro: "Nu există facturi plătite", en: "No paid invoices" },
    pdf: { ro: "PDF", en: "PDF" },
    print: { ro: "Print", en: "Print" },
    share: { ro: "Partajează", en: "Share" },
  },
  
  // Share Modal
  shareModal: {
    title: { ro: "Partajează / Trimite Factură", en: "Share / Send Invoice" },
    copyLink: { ro: "Copiază link (30 zile)", en: "Copy link (30 days)" },
    downloadPdf: { ro: "Descarcă PDF", en: "Download PDF" },
    sendEmail: { ro: "Trimite Email", en: "Send Email" },
    sending: { ro: "Se trimite...", en: "Sending..." },
  },
  
  // Archive Modal
  archiveModal: {
    title: { ro: "Arhivează cererile selectate?", en: "Archive selected requests?" },
    requestsWillBeArchived: { ro: "cereri vor fi arhivate.", en: "requests will be archived." },
    paidRequestsSkipped: { ro: "cereri plătite vor fi sărite pentru audit.", en: "paid requests will be skipped for audit." },
    archiveReason: { ro: "Motiv arhivare (opțional)", en: "Archive reason (optional)" },
    archiveReasonPlaceholder: { ro: "Ex: Cereri vechi, anulate de client, etc.", en: "E.g.: Old requests, cancelled by client, etc." },
    archive: { ro: "Arhivează", en: "Archive" },
    archiving: { ro: "Se arhivează...", en: "Archiving..." },
  },
  
  // Unarchive Modal
  unarchiveModal: {
    title: { ro: "Dezarhivează cererile selectate?", en: "Unarchive selected requests?" },
    requestsWillBeUnarchived: { ro: "cereri vor fi dezarhivate și vor reapărea în lista activă.", en: "requests will be unarchived and will reappear in the active list." },
    unarchive: { ro: "Dezarhivează", en: "Unarchive" },
    unarchiving: { ro: "Se dezarhivează...", en: "Unarchiving..." },
  },
  
  // Toast Messages
  toasts: {
    linkShared: { ro: "Link partajat!", en: "Link shared!" },
    linkCopied: { ro: "Link copiat în clipboard!", en: "Link copied to clipboard!" },
    staffLinkShared: { ro: "Link Staff partajat!", en: "Staff link shared!" },
    staffLinkCopied: { ro: "Link Staff copiat în clipboard!", en: "Staff link copied to clipboard!" },
    logoutSuccess: { ro: "Deconectat cu succes", en: "Logged out successfully" },
    logoutError: { ro: "Eroare la deconectare", en: "Logout error" },
    dataLoadError: { ro: "Eroare la încărcarea datelor", en: "Error loading data" },
    invoiceLoadError: { ro: "Eroare la încărcarea facturilor", en: "Error loading invoices" },
    invoicePrintError: { ro: "Nu s-a putut tipări factura", en: "Could not print invoice" },
    shareError: { ro: "Eroare la partajare", en: "Share error" },
    linkCopiedSuccess: { ro: "Link copiat!", en: "Link copied!" },
    copyError: { ro: "Nu s-a putut copia linkul", en: "Could not copy link" },
    invoiceSentSuccess: { ro: "Factura a fost trimisă pe email", en: "Invoice sent by email" },
    emailSendError: { ro: "Eroare la trimiterea emailului", en: "Error sending email" },
    archiveError: { ro: "Eroare la arhivare", en: "Archive error" },
    unarchiveError: { ro: "Eroare la dezarhivare", en: "Unarchive error" },
    shareError: { ro: "Eroare la distribuire", en: "Share failed" },
  },
  
  // Owner Statistics (OWNER only)
  ownerStats: {
    totalVisits: { ro: "Total Vizite", en: "Total Visits" },
    uniqueVisitors: { ro: "Vizitatori Unici", en: "Unique Visitors" },
    requestsReceived: { ro: "Cereri Primite", en: "Requests Received" },
    paidOrders: { ro: "Comenzi Plătite", en: "Paid Orders" },
  },
  
  // Bulk Invoice Management (OWNER only)
  bulkInvoices: {
    filterByPeriod: { ro: "Filtrează după perioadă", en: "Filter by period" },
    fromDate: { ro: "De la", en: "From" },
    toDate: { ro: "Până la", en: "To" },
    applyFilter: { ro: "Aplică filtru", en: "Apply filter" },
    clearFilter: { ro: "Șterge filtru", en: "Clear filter" },
    selectAll: { ro: "Selectează toate", en: "Select all" },
    deselectAll: { ro: "Deselectează toate", en: "Deselect all" },
    selectedInvoices: { ro: "facturi selectate", en: "invoices selected" },
    selectedTotal: { ro: "Total selectat", en: "Selected total" },
    bulkActions: { ro: "Acțiuni în bloc", en: "Bulk actions" },
    printAll: { ro: "Printează toate", en: "Print all" },
    downloadAllPdfs: { ro: "Descarcă toate PDF-urile", en: "Download all PDFs" },
    shareSelected: { ro: "Distribuie selectate", en: "Share selected" },
    generateSummary: { ro: "Generează rezumat", en: "Generate summary" },
    summaryReport: { ro: "Rezumat / Centralizator", en: "Summary Report" },
    invoiceNumber: { ro: "Nr. Factură", en: "Invoice No." },
    date: { ro: "Dată", en: "Date" },
    time: { ro: "Oră", en: "Time" },
    amount: { ro: "Sumă", en: "Amount" },
    grandTotal: { ro: "TOTAL GENERAL", en: "GRAND TOTAL" },
    printSummary: { ro: "Printează rezumat", en: "Print summary" },
    downloadSummary: { ro: "Descarcă rezumat PDF", en: "Download summary PDF" },
    shareSummary: { ro: "Distribuie rezumat", en: "Share summary" },
    shareVia: { ro: "Distribuie prin", en: "Share via" },
    email: { ro: "Email", en: "Email" },
    whatsapp: { ro: "WhatsApp", en: "WhatsApp" },
    copyLink: { ro: "Copiază link", en: "Copy link" },
    download: { ro: "Descarcă", en: "Download" },
    close: { ro: "Închide", en: "Close" },
    noInvoicesInPeriod: { ro: "Nu există facturi în perioada selectată", en: "No invoices in selected period" },
    preparingPdfs: { ro: "Se pregătesc PDF-urile...", en: "Preparing PDFs..." },
    generatingSummary: { ro: "Se generează rezumatul...", en: "Generating summary..." },
    summaryGenerated: { ro: "Rezumat generat cu succes", en: "Summary generated successfully" },
    pdfsReady: { ro: "PDF-urile sunt gata", en: "PDFs are ready" },
    client: { ro: "Client", en: "Client" },
    filterActive: { ro: "Filtru activ", en: "Filter active" },
    shareSuccess: { ro: "Document distribuit cu succes", en: "Document shared successfully" },
    pdfDownloaded: { ro: "PDF descărcat. Client email deschis.", en: "PDF downloaded. Email client opened." },
  },
  
  // Language Switcher
  languageSwitcher: {
    language: { ro: "Limbă", en: "Language" },
    romanian: { ro: "Română", en: "Romanian" },
    english: { ro: "Engleză", en: "English" },
  },
};

// Helper function to get translation
export const t = (translations, key, lang) => {
  const keys = key.split(".");
  let value = translations;
  for (const k of keys) {
    value = value?.[k];
  }
  return value?.[lang] || value?.en || key;
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Get saved language from localStorage or default to Romanian
    if (typeof window !== "undefined") {
      return localStorage.getItem("adminLanguage") || "ro";
    }
    return "ro";
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem("adminLanguage", language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "ro" ? "en" : "ro"));
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t: (key) => {
      const keys = key.split(".");
      let value = translations;
      for (const k of keys) {
        value = value?.[k];
      }
      return value?.[language] || value?.en || key;
    },
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}

export default LanguageContext;
